<template>
  <div>
    <div v-if="visible" class="header-banner">
      <img src="/image/header-banner.jpg" alt="" />
    </div>
    <van-tabs
      class="main-tabs"
      v-if="visible"
      v-model="active"
      @change="navBarChange"
    >
      <template v-for="item in menus">
        <van-tab :key="item.name" :name="item.name" :title="item.meta.title">
          <template #title>
            <span class="title-cell">
              <img
                v-if="item.name == active"
                :src="`/image/${item.meta.icon}.png`"
                class="img"
              />
              <img
                v-else
                :src="`/image/${item.meta.icon}-r.png`"
                class="img red"
              />
              <span class="text">{{ item.meta.title }}</span>
            </span>
          </template>
        </van-tab>
      </template>
    </van-tabs>
    <navbar v-else />
  </div>
</template>

<script>
import { asyncRoutes } from "@/router/router.config"
import authApi from "@/api/auth"
export default {
  data() {
    return {
      active: "",
      menus: [],
      visible: true,
      permissionsList: [],
    }
  },
  watch: {
    $route: {
      handler(val) {
        const meta = val.meta
        const matched = val.matched
        this.visible = meta && meta.showMainMenu ? true : false
        let name = this.defalutActive
        if (matched.length > 1) {
          name = matched[1].name
        }
        this.active = name
      },
      immediate: true,
    },
  },
  mounted() {
    const menus = asyncRoutes.find((item) => item.path === "/").children
    const menulist = this.filterMenus(menus)
    //过滤菜单 通过权限
    authApi.QueryMyPermissions().then((res) => {
      this.permissionsList = res.Data.Permissions
      const menusPermissionList = []
      for (let i = 0; i < menulist.length; i++) {
        for (let j = 0; j < this.permissionsList.length; j++) {
          if (this.permissionsList[j].indexOf(menulist[i].meta.title) > -1) {
            menusPermissionList.push(menulist[i])
          }
        }
      }
      this.menus = menusPermissionList
    })
  },
  methods: {
    navBarChange(name) {
      console.log(name)
      this.$router.push({ name })
    },
    /**
     * @description: 菜单过滤
     * @param {*} menus
     * @return {*}
     */
    filterMenus(menus) {
      return menus.filter((item) => item.meta && item.meta.showMainMenu)
    },
  },
}
</script>
<style lang="less" scoped>
.main-tabs {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
/deep/.van-tab {
  color: #333;
}
/deep/.van-tabs__wrap {
  height: 50px;
  line-height: 50px;
}
/deep/.van-tab--active {
  background-color: rgb(210, 0, 1);
  color: white;
}
/deep/.van-tabs__line {
  display: none;
}
.header-banner {
  font-size: 0;
  img {
    width: 100%;
  }
}
.title-cell {
  display: flex;
  align-items: center;
  .img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 6px;
    &.red {
      width: 22px;
      height: 22px;
    }
  }
}
</style>
